
import { Component, Vue, Prop } from "vue-property-decorator";
import { TNps_Score } from "@/models/nps_score";
import { API_ROUTES } from "@/utils/API";
import { SMNps, SMCases } from "@/store";
import { track } from "@amplitude/analytics-browser";
import { NpsScoreTypes } from "@/constants/nps_score_types";

@Component({})
export default class VNotificationTemplate extends Vue {
  @Prop({ type: Boolean, default: false }) readonly isCompliance!: boolean;

  npsData: TNps_Score = {
    score: -1,
    comment: "",
  };

  isConsented = false;

  loading = false;

  isSubmitted = false;

  get canGoNext() {
    return this.npsData.score >= 0 && !!this.npsData.comment;
  }

  get title() {
    const typeName = SMNps.npsTypeName;

    const key = `nps.title.${typeName}`;

    return this.$te?.(key) ? this.$t(key) : this.$t("nps.title.default");
  }

  async submitNps() {
    try {
      if (!SMNps.npsTypeName) return;

      const payload = {
        score: this.npsData.score,
        comment: this.npsData.comment,
        score_type: NpsScoreTypes[SMNps.npsTypeName] || "",
        case_id: SMCases.caseId || 0,
        consent: this.isConsented,
      };

      await this.axios.post(API_ROUTES.SEND_NPS_SCORE, payload);

      if (!SMNps.npsTypeName) return;

      localStorage.setItem(`nps_${SMNps.npsTypeName}`, "true");

      track("NPS Submitted", {
        score: this.npsData.score,
        comment: this.npsData.comment,
        score_type: SMNps.npsTypeName,
        consent: this.isConsented,
        case_id: SMCases.caseId || 0,
      });
    } catch (e) {
      console.log(e);
    } finally {
      this.isSubmitted = true;

      // this.closeNps();
    }
  }

  closeNps() {
    this.$emit("close");
  }
}
